import { useEffect, useState } from 'react';
import { linkHandler } from 'utils/linkHandler';
import { TEXT } from 'locales/translations';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Headline, Paragraph, Toggle, Amount, Spinner } from 'Common';
import PrivacyPolicyLink from 'components/PrivacyPolicyLink';
import TermsOfServiceLink from 'components/TermsOfServiceLink';
import { AccessibilityLink, HealthRequirementsHint } from 'Component';
import { getZppCertifiedSubscriptionPlan } from 'redux/query';
import { selectSubscriptionPlan, getSubscriptionPlansRequest } from 'redux/actions';
import { useHistory } from 'react-router-dom';
import { SUBSCRIPTION_PLAN_GROUPS } from 'utils/subscriptionPlanGroups';
import { colors } from 'Theme';
import Style from './HealthInsuranceCheckoutBox.style';

export const HealthInsuranceCheckoutBox = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [healthRequirementChecked, setHealthRequirementChecked] = useState(false);
  const [termsChecked, setTermsChecked] = useState(false);
  const subscriptionPlan = useSelector(getZppCertifiedSubscriptionPlan({ course: 'sda' })) ?? null;

  const { infoText, interval, approvalText_2, approvalText_3, ctaBtn, asteriskText } = TEXT.refundBox;
  useEffect(() => {
    dispatch(getSubscriptionPlansRequest(SUBSCRIPTION_PLAN_GROUPS.NULL));
  }, []);

  const handleOnClickHealthRequirements = () => {
    setHealthRequirementChecked(!healthRequirementChecked);
  };

  const handleOnClickTerms = () => {
    setTermsChecked(!termsChecked);
  };

  const handleOnSelectedPlan = () => {
    dispatch(selectSubscriptionPlan(subscriptionPlan.id));
    history.push(linkHandler.get('checkout'));
  };

  let disabledButton = true;
  if (healthRequirementChecked && termsChecked) {
    disabledButton = false;
  }
  return subscriptionPlan ? (
    <Style id="section-checkout-box" className="px-5 py-5 px-md-4 px-lg-5 d-flex flex-column align-items-center mx-auto mt-5 mt-md-0">
      <Headline level={4} className="mb-0" data-cy-name="health-insurance-checkout-box-title">
        {subscriptionPlan.title}
      </Headline>
      <Paragraph>{infoText}</Paragraph>
      <Headline level={1} className="mb-2 align-self-center">
        <Amount value={subscriptionPlan.chargeAmount} currency={subscriptionPlan.currency} />
      </Headline>
      <Paragraph>{interval}</Paragraph>
      <Toggle className="mb-4" checked={healthRequirementChecked} id="switch1" onChange={handleOnClickHealthRequirements}>
        <HealthRequirementsHint paragraphClassName="small text-start mb-0 ps-2" />
      </Toggle>
      <Toggle className="mb-4" checked={termsChecked} id="switch2" onChange={handleOnClickTerms}>
        <Paragraph className="small text-start mb-0 ps-2">
          {approvalText_2} <TermsOfServiceLink buttonText="AGB" color={colors.green.c500} /> {approvalText_3}{' '}
          <PrivacyPolicyLink buttonText="Datenschutz" color={colors.green.c500} />{' '}
        </Paragraph>
      </Toggle>
      <div className="text-center">
        <Button className="btn-w-auto mt-auto" onClick={handleOnSelectedPlan} disabled={disabledButton}>
          {ctaBtn}
        </Button>
      </div>

      <div className="plans-box-kk__info-text mt-4 px-3 px-md-0">
        <Paragraph className="extra-small">
          {asteriskText}
          <br />
          Zu den <AccessibilityLink />
        </Paragraph>
      </div>
    </Style>
  ) : (
    <div id="section-checkout-box" className="d-flex flex-column mx-auto mt-auto text-center h-100 kk_info_box justify-content-center">
      <Spinner />
    </div>
  );
};
